import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoshanishingnapurcab() {



const cardData = {
  keyword: " Mumbai to Shani Shingnapur Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Shani Shingnapur cab services for devotees and travelers planning a spiritual trip to one of Maharashtra’s most famous pilgrimage destinations. Shani Shingnapur is widely known for the sacred temple dedicated to Lord Shani (Saturn) and the unique tradition of houses without doors in the village. Whether you are planning a one-day pilgrimage, a family spiritual trip, or a combined tour including nearby religious places like Shirdi, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way rides, round-trip packages, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, professional chauffeurs experienced in long-distance travel, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Shani Shingnapur cab booking.",

topPlaces: [
  {
    title: "Shani Shingnapur Temple",
    description:
      "Shani Shingnapur Temple is the main attraction of the village and one of the most revered temples dedicated to Lord Shani in India. Unlike traditional temples, the deity here is a black stone idol placed on an open platform without a roof or temple structure. Devotees from across the country visit to offer oil, prayers, and rituals to seek protection from negative planetary effects. The temple is especially crowded on Saturdays and during Shani Jayanti celebrations. Traveling by cab from Mumbai allows pilgrims to comfortably reach the temple and spend enough time performing rituals and darshan without worrying about transportation."
  },
  {
    title: "Shirdi Sai Baba Temple",
    description:
      "Shirdi Sai Baba Temple is one of the most visited pilgrimage sites in India and is located about 70 kilometers from Shani Shingnapur. Devotees visit to seek blessings at the Samadhi Mandir of Sai Baba and participate in daily aarti ceremonies. Many pilgrims combine visits to Shirdi and Shani Shingnapur in the same trip due to their close proximity. Booking a cab from Mumbai allows travelers to easily plan a spiritual itinerary covering both sacred destinations comfortably."
  },
  {
    title: "Dwarkamai Mosque",
    description:
      "Dwarkamai Mosque in Shirdi is a sacred place where Sai Baba spent many years of his life. The mosque holds great spiritual importance and houses the sacred fire known as the Dhuni that continues to burn even today. Devotees visit this place to experience the peaceful environment and to understand the spiritual teachings of Sai Baba. A comfortable cab journey makes it easy to include Dwarkamai as part of your pilgrimage trip."
  },
  {
    title: "Chavadi Shirdi",
    description:
      "Chavadi is another important spiritual site associated with Sai Baba, where he used to rest on alternate nights during his lifetime. Today, devotees visit the place to see the preserved room and participate in the famous Thursday Chavadi procession. The site holds deep religious significance and forms an essential part of the Shirdi pilgrimage experience. Traveling by cab allows devotees to conveniently visit Chavadi along with other important temples nearby."
  },
  {
    title: "Sai Heritage Village",
    description:
      "Sai Heritage Village is a cultural and spiritual theme park near Shirdi that recreates scenes from Sai Baba’s life through life-size statues and detailed displays. Visitors can walk through various sections showing important events and teachings from Sai Baba’s life. The attraction is educational and spiritually inspiring for devotees and tourists alike. A cab ride ensures comfortable travel from Shani Shingnapur to this unique cultural attraction."
  },
  {
    title: "Wet N Joy Water Park Shirdi",
    description:
      "Wet N Joy Water Park in Shirdi is a modern recreational attraction where families and travelers can relax after visiting the temples. The park features exciting water rides, wave pools, and entertainment zones suitable for visitors of all ages. Many tourists include it in their itinerary when traveling with family. A cab service allows convenient travel to the park while exploring Shirdi and Shani Shingnapur in the same trip."
  },
  {
    title: "Khandoba Temple",
    description:
      "Khandoba Temple in Shirdi is a historic temple dedicated to Lord Khandoba and is known as the place where Sai Baba was first addressed as 'Sai'. The temple has strong historical and spiritual significance for devotees. Visitors often begin their Shirdi pilgrimage by visiting this temple before heading to the Sai Baba Samadhi Mandir. Traveling by cab makes it easy to include this sacred temple in your spiritual journey."
  },
  {
    title: "Maruti Mandir Shani Shingnapur",
    description:
      "Maruti Mandir in Shani Shingnapur is a small but important temple dedicated to Lord Hanuman. Devotees often visit this temple before or after visiting the Shani Temple as part of their spiritual routine. The temple is peaceful and attracts pilgrims seeking strength and protection. A cab journey allows travelers to explore this temple conveniently during their visit to Shani Shingnapur."
  },
  {
    title: "Shani Amrut Tirth",
    description:
      "Shani Amrut Tirth is a sacred water body located near the Shani Shingnapur Temple where devotees perform purification rituals before offering prayers to Lord Shani. Many pilgrims believe that taking a ritual bath here cleanses negative influences and prepares them spiritually for temple darshan. Visiting by cab allows devotees to comfortably explore the surrounding spiritual spots and complete their pilgrimage with ease."
  },
  {
    title: "Shani Shingnapur Village Experience",
    description:
      "The village of Shani Shingnapur itself is a unique attraction known for its tradition of houses without doors or locks. Locals believe that Lord Shani protects the village from theft and crime, making it a fascinating cultural and spiritual phenomenon. Visitors often walk through the village to observe this unusual practice and learn about the local traditions and beliefs. Traveling by cab from Mumbai allows tourists to comfortably reach the village and explore its culture along with the temple."
  }
],



services: [
{
name: "Mumbai to Shani Shingnapur Cab",
description: "Mumbai to Shani Shingnapur cab service provides comfortable transportation for devotees traveling to the famous Shani Shingnapur temple in Ahmednagar district of Maharashtra. The temple is one of the most visited pilgrimage destinations dedicated to Lord Shani, attracting thousands of devotees every day. Our long-distance cabs are suitable for highway journeys and provide comfortable seating and luggage space for families and groups. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles ensure comfortable travel throughout the journey. Ideal for temple visits, religious tours, and family pilgrimages. Flexible booking options allow easy travel planning."
},
{
name: "Mumbai to Shani Shingnapur Taxi",
description: "Mumbai to Shani Shingnapur taxi service offers reliable transportation for devotees visiting the sacred Shani temple for darshan and spiritual travel. The route from Mumbai to Shani Shingnapur passes through major highways ensuring smooth travel for long-distance journeys. Vehicles are well maintained and provide spacious seating suitable for families and groups traveling together. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage travel, weekend temple visits, and family trips. Air-conditioned vehicles ensure relaxed journeys throughout the trip."
},
{
name: "Shani Shingnapur Cab from Mumbai",
description: "Shani Shingnapur cab from Mumbai offers convenient travel for devotees planning temple visits to the famous Shani shrine. The journey connects Mumbai to Ahmednagar district through well-developed highways suitable for comfortable road travel. Vehicles provide spacious seating and smooth ride quality for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours, religious journeys, and family travel. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow convenient ride scheduling."
},
{
name: "Shani Shingnapur Temple Cab Mumbai",
description: "Shani Shingnapur temple cab service from Mumbai provides reliable transportation for devotees visiting the sacred temple dedicated to Lord Shani. The temple is famous for its open-air shrine and strong spiritual significance among devotees. Vehicles used for temple travel are comfortable and suitable for long highway journeys. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for family pilgrimages and spiritual tours. Spacious seating ensures comfortable travel for groups and families. Flexible cab booking options allow easy travel planning."
},
{
name: "Mumbai to Shani Shingnapur Cab Service",
description: "Mumbai to Shani Shingnapur cab service offers dependable long-distance transportation for devotees planning temple visits and religious tours. Vehicles are suitable for highway travel and provide comfortable seating and luggage space for passengers. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage travel, family trips, and temple tours. Air-conditioned vehicles ensure comfortable journeys throughout the trip. Flexible booking options allow easy cab reservations anytime."
},
{
name: "Mumbai to Shani Shingnapur Taxi Service",
description: "Mumbai to Shani Shingnapur taxi service provides convenient transportation for devotees visiting the holy temple dedicated to Lord Shani. The journey is comfortable with well-maintained vehicles designed for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for religious travel, temple visits, and family pilgrimages. Air-conditioned vehicles ensure relaxed journeys throughout the trip. Flexible taxi booking options allow passengers to easily schedule their rides."
},
{
name: "Mumbai to Shani Shingnapur Cab Booking",
description: "Mumbai to Shani Shingnapur cab booking allows devotees to easily reserve vehicles for temple visits and religious travel. Online and phone booking options provide quick confirmations and convenient ride scheduling. Vehicles used for temple tours are comfortable and suitable for highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage travel, family trips, and group temple tours. Comfortable interiors ensure relaxed travel experiences."
},
{
name: "Mumbai to Shani Shingnapur Taxi Booking Online",
description: "Mumbai to Shani Shingnapur taxi booking online provides convenient digital reservations for devotees planning temple visits. Travelers can easily schedule pickups and receive instant confirmation for their journey. Vehicles provide comfortable seating and smooth ride performance suitable for long-distance highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for families, tourists, and devotees visiting the temple. Flexible online booking options allow easy travel planning."
},
{
name: "Mumbai to Shani Shingnapur Cab Price",
description: "Mumbai to Shani Shingnapur cab price options provide transparent fare estimates for devotees planning temple travel. Pricing depends on vehicle type, travel distance, and trip duration. Travelers can choose sedan, SUV, or MPV vehicles depending on comfort preferences and group size. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage travel and family temple visits. Comfortable vehicles ensure relaxed journeys throughout the trip."
},
{
name: "Mumbai to Shani Shingnapur Taxi Fare",
description: "Mumbai to Shani Shingnapur taxi fare services offer flexible pricing options based on vehicle category and travel duration. Travelers can choose economical sedans or spacious SUVs depending on comfort needs. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage travel, family trips, and temple visits. Comfortable vehicles ensure relaxed journeys throughout the journey. Transparent fare structure allows easy travel planning."
},
{
name: "Mumbai to Shani Shingnapur One Way Cab",
description: "Mumbai to Shani Shingnapur one way cab service offers economical intercity travel without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for devotees traveling one way for temple visits. Air-conditioned vehicles ensure comfortable journeys throughout the trip. Flexible booking options allow quick ride reservations."
},
{
name: "Mumbai to Shani Shingnapur Round Trip Taxi",
description: "Mumbai to Shani Shingnapur round trip taxi service provides convenient transportation for devotees planning return travel after temple darshan. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family pilgrimages and religious tours. Comfortable interiors ensure relaxed journeys throughout the trip. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Mumbai to Shani Shingnapur Innova Cab",
description: "Mumbai to Shani Shingnapur Innova cab service provides spacious MPV transportation ideal for families and group pilgrimage travel. The Toyota Innova offers comfortable seating, smooth highway performance, and ample luggage space for temple journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips and religious tours. Comfortable interiors ensure relaxed travel experiences. Flexible booking options allow convenient ride scheduling."
},
{
name: "Mumbai to Shani Shingnapur Ertiga Cab",
description: "Mumbai to Shani Shingnapur Ertiga cab service offers comfortable MPV transportation suitable for small families and groups visiting the temple. The Maruti Ertiga provides spacious seating and smooth ride quality for long-distance highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for temple visits and religious travel. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Religious Tour Cab Shani Shingnapur",
description: "Religious tour cab to Shani Shingnapur from Mumbai provides dedicated transportation for spiritual journeys and temple visits. The temple is one of the most important Shani temples in India and attracts devotees throughout the year. Vehicles used for religious tours provide comfortable seating and smooth highway performance for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours, temple visits, and spiritual travel. Flexible booking options allow customized religious tour planning."
}
],

tableData: [
["Mumbai to Shani Shingnapur Cab","Mumbai to Shani Shingnapur Taxi"],
["Shani Shingnapur Cab from Mumbai","Shani Shingnapur Temple Cab Mumbai"],
["Mumbai to Shani Shingnapur Cab Service","Mumbai to Shani Shingnapur Taxi Service"],
["Mumbai to Shani Shingnapur Cab Booking","Mumbai to Shani Shingnapur Taxi Booking Online"],
["Mumbai to Shani Shingnapur Cab Price","Mumbai to Shani Shingnapur Taxi Fare"],
["Mumbai to Shani Shingnapur One Way Cab","Mumbai to Shani Shingnapur Round Trip Taxi"],
["Mumbai to Shani Shingnapur Innova Cab","Mumbai to Shani Shingnapur Ertiga Cab"],
["Religious Tour Cab Shani Shingnapur","Temple Tour Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are experienced in long-distance pilgrimage travel from Mumbai to Shani Shingnapur. They are familiar with temple routes, highway driving, and local road conditions ensuring a safe and comfortable spiritual journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Shani Shingnapur cab bookings. Customers receive complete details about per-kilometer charges, tolls, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Shani Shingnapur cab service operates 24 hours a day. Whether you want to start early morning for temple darshan or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable journey during the long-distance temple trip."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab booking, round trips, and same-day return packages from Mumbai to Shani Shingnapur temple."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Shani Shingnapur pilgrimage begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Temple Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees traveling from Mumbai to Shani Shingnapur. Our punctual drivers, comfortable vehicles, and professional service ensure a peaceful spiritual journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Shani Shingnapur?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Shani Shingnapur temple for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Shani Shingnapur?", answer: "The distance from Mumbai to Shani Shingnapur is approximately 300 km and the journey usually takes around 6 to 7 hours depending on traffic and road conditions." },
  { question: "Can I combine Shirdi and Shani Shingnapur in one trip?", answer: "Yes, many travelers combine Shirdi Sai Baba Temple and Shani Shingnapur temple in one pilgrimage trip from Mumbai." },
  { question: "Which vehicles are available for the trip?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Shani Shingnapur cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and festival seasons when many devotees visit the temple." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Shani Shingnapur." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sunil Deshmukh",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Shani Shingnapur pilgrimage. The driver was very professional and the journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Kulkarni",
    feedback:
      "Excellent cab service for temple travel. Comfortable vehicle and punctual driver made our Shani Shingnapur trip very peaceful.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shani Shingnapur Cab",
  "description": "Omshree Cab provides reliable cab services from Mumbai to Shani Shingnapur for temple visits, one-way trips, and round trips. Travel comfortably with Innova, Ertiga, and other well-maintained vehicles. Enjoy safe, punctual, and convenient journeys with flexible booking options and transparent pricing for family and religious tours.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "870"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai to Shani Shingnapur Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services from Mumbai to Shani Shingnapur for temple visits, one-way trips, and round trips. Travel with Innova, Ertiga, and other vehicles. Safe, punctual, and convenient journeys with flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshanishingnapurcab;